<template>
    <div class="collection-catalogues">
      <div id="pdf-viewer" :class="{ open: pdfUrl }">
        <v-btn class="btn-close" icon @click.stop="pdfUrl = ''">
          <img src="/static/img/icons/close.svg" alt="close" class="close">
        </v-btn>
        <iframe :src="pdfUrl" frameborder="0"></iframe>
      </div>
      <template v-if="lang === 'de'">
        <h3>Sammlungskataloge</h3>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing"
              @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K00_1900_Verzeichniss-der-Kunst-Sammlung_Mainz.pdf'"
            >
                <em>Verzeichnis der Rudolf Mosse'schen Kunst-Sammlung</em>, Berlin 1900<br>
                Gutenberg-Museum Mainz, Bibliothek (1900 Ha 8)
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2019/10/Katalog_Mosse_1900_Thumbnail-e1572016559548.jpg"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K00_1900_Verzeichniss-der-Kunst-Sammlung_Mainz.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing"
              @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K08_KBB_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1908-Leo-Baeck.pdf'"
            >
                <em>Katalog der Rudolf Mosse'schen Kunstsammlung</em>, Berlin 1908<br>
                Leo Baeck Institute New York / Berlin<br>Staatsbibliothek zu Berlin (Ns 10680)
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K_1908_Cover_thumbnail.jpg"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K08_KBB_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1908-Leo-Baeck.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing"
              @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1912_UB-Marburg.pdf'"
            >
              <em>Katalog der Kunstsammlung Rudolf Mosse</em>, Berlin 1912<br>
              Universitätsbibliothek Marburg, Bibliothek Kunst und Kulturwissenschaften, Kunstgeschichte (R 447)
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1912_UB-Marburg-Thn.png"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1912_UB-Marburg.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing">
              <em>Katalog der Kunstsammlung Rudolf Mosse</em>, Berlin 1913<br>
              Universitätsbibliothek Marburg, Bibliothek Kunst und Kulturwissenschaften, Kunstgeschichte (R&nbsp;447/1)
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1913_UB-Marburg-Thn.png"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1913_UB-Marburg.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing"
              @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K15_Florenz_Katalog_der_Sammlung_-Mosse.pdf'"
            >
              <em>Katalog der Kunstsammlung Rudolf Mosse</em>, Berlin 1915<br>
              Kunsthistorisches Institut Florenz (Z 5434)
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2025/04/katalog-der-kunstsammlung-rudolf-mosse-berlin-1915-cover.jpg"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K15_Florenz_Katalog_der_Sammlung_-Mosse.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing"
              @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K21_LBI_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1921-Leo-Baeck.pdf'"
            >
              <em>Katalog der Kunstsammlung Rudolf Mosse</em>, Berlin 1921<br>
              Leo Baeck Institute New York / Berlin, Mosse Family Collection, AR 25184, Box 2, Folder 23
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2025/04/katalog-der-kunstsammlung-rudolf-mosse-berlin-1921-cover.jpg"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K21_LBI_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1921-Leo-Baeck.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing"
              @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K32_1932-Haus-der-Sammlungen-Rudolf-Mosse-1929_1932.pdf'"
            >
            [Katalog] <em>Haus der Sammlungen Rudolf Mosse</em>, [Berlin] 1932<br>
          Leo Baeck Institute New York / Berlin, Mosse Family Collection, AR 25184, Box 2, Folder 23<br>
          Staatsbibliothek zu Berlin, Signatur: 4“ Ns 10681
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2025/04/haus-der-sammlungen-rudolf-mosse-berlin-1932-cover.jpg"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K32_1932-Haus-der-Sammlungen-Rudolf-Mosse-1929_1932.pdf'"
              />
            </div>
        </div>
      </template>
      <template v-else>
        <h3>Collection Catalogs</h3>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing">
                <em>Verzeichnis der Rudolf Mosse'schen Kunst-Sammlung</em>, Berlin 1900<br>Gutenberg-Museum Mainz, Bibliothek (1900 Ha 8)
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2019/10/Katalog_Mosse_1900_Thumbnail-e1572016559548.jpg"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K00_1900_Verzeichniss-der-Kunst-Sammlung_Mainz.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing">
                <em>Katalog der Rudolf Mosse'schen Kunstsammlung</em>, Berlin 1908<br>Leo Baeck Institute New York / Berlin<br>Staatsbibliothek zu Berlin (Ns 10680)
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K_1908_Cover_thumbnail.jpg"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K08_KBB_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1908-Leo-Baeck.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing">
              <em>Katalog der Kunstsammlung Rudolf Mosse</em>, Berlin 1912<br>
              Universitätsbibliothek Marburg, Bibliothek Kunst und Kulturwissenschaften, Kunstgeschichte (R 447)
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1912_UB-Marburg-Thn.png"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1912_UB-Marburg.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing">
              <em>Katalog der Kunstsammlung Rudolf Mosse</em>, Berlin 1913<br>
              Universitätsbibliothek Marburg, Bibliothek Kunst und Kulturwissenschaften, Kunstgeschichte (R 447/1)
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1913_UB-Marburg-Thn.png"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1913_UB-Marburg.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing"
              @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K15_Florenz_Katalog_der_Sammlung_-Mosse.pdf'"
            >
              <em>Katalog der Kunstsammlung Rudolf Mosse</em>, Berlin 1915<br>
              Kunsthistorisches Institut Florenz (Z 5434)
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2025/04/katalog-der-kunstsammlung-rudolf-mosse-berlin-1915-cover.jpg"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K15_Florenz_Katalog_der_Sammlung_-Mosse.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing"
              @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K21_LBI_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1921-Leo-Baeck.pdf'"
            >
              <em>Katalog der Kunstsammlung Rudolf Mosse</em>, Berlin 1921<br>
              Leo Baeck Institute New York / Berlin, Mosse Family Collection, AR 25184, Box 2, Folder 23
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2025/04/katalog-der-kunstsammlung-rudolf-mosse-berlin-1921-cover.jpg"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K21_LBI_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1921-Leo-Baeck.pdf'"
              />
            </div>
        </div>
        <div class="mari-catalogue-item">
            <div class="mari-catalogue-listing"
              @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K32_1932-Haus-der-Sammlungen-Rudolf-Mosse-1929_1932.pdf'"
            >
            Katalog <em>Haus der Sammlungen Rudolf Mosse</em>, Berlin 1932<br>
          Leo Baeck Institute New York / Berlin, Mosse Family Collection, AR 25184, Box 2, Folder 23<br>
          Staatsbibliothek zu Berlin, Signatur: 4“ Ns 10681
            </div>
            <div class="wp-block-image mari-catalogue-thumb">
              <img
                  class="mari-catalogue"
                  src="https://www.mari-portal.de/wp/wp-content/uploads/2025/04/haus-der-sammlungen-rudolf-mosse-berlin-1932-cover.jpg"
                  @click="pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K32_1932-Haus-der-Sammlungen-Rudolf-Mosse-1929_1932.pdf'"
              />
            </div>
        </div>
      </template>
    </div>
</template>

<script>
export default {
  data () {
    return {
      pdfUrl: ''
    }
  },
  props: {
    lang: {
      type: String
    }
  }
}
</script>

<style lang="scss">
.mari-catalogue-listing {
  text-decoration: underline;
  cursor: pointer;
}
.collection-catalogues {
  h3 {
    margin-bottom: 2rem;
  }
}
.mari-catalogue {
  cursor: pointer;
}
.mari-catalogue-item {
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;

  // &:after {
  //   display: block;
  //   content: '';
  //   clear: both;
  // }
  .mari-catalogue-listing {
    flex: 1 1 auto;
  }
}
.mari-catalogue-thumb {
  // padding-left: 2rem;

//  figure {
//     margin: 0 !important;
//     max-width: 8rem;
//     float: right
//   }
  img {
    max-width: 8rem !important;
    width: 8rem;
    // height: auto;
    // display: block;
  }
}
#pdf-viewer {
  position: fixed;
  top: 50%;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  z-index: -1;
  background-color: rgba(0, 0, 0, .8);
  transition: all .5s;
  width: 100%;
  padding: 4rem 4rem 2rem;
  transform: scaleX(0);

  &.open {
    z-index: 1004;
    top: 0;
    opacity: 1;
    transform: scaleX(1);
  }

  .btn-close {
    width: 4rem;
    position: absolute;
    z-index: 1;
    right: 0;
    top: 1rem;

    .v-btn__content {
      &:before {
        content: none !important;
      }
    }
  }

  iframe {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/static/Collection-catalogues.vue